module.exports = __webpack_public_path__ + "static/media/specialty-hotel.89a4dc28.svg";